import { safeParse } from 'valibot'
import { StateMapDisk, StateMapDiskSchema } from './state_map_disk.enum'

export function ensureStateMapDisk(value?: string | null, fallback?: () => StateMapDisk): StateMapDisk {
  if (value == null || value === '') {
    if (fallback) {
      return fallback()
    }
    throw new Error('Missing state map disk')
  }

  const result = safeParse(StateMapDiskSchema, value)
  if (!result.success) {
    throw new Error('Invalid disk: ' + value)
  }

  return result.output
}
